// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="10.5" y="4" width="3" height="11" fill={props.color} />
			<rect x="10.5" y="17" width="3" height="3" fill={props.color} />
		</svg>
	</>
);

export default Icon;
